<template>
  <div class="w-full bg-white group relative shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-300 rounded-2xl overflow-hidden">
    <!-- Image & Video -->
    <div
      v-if="media"
      class="w-full relative flex overflow-hidden rounded-t-2xl"
    >
      <!-- Image -->
      <a
        data-fancybox="gallery"
        :href="fancyboxHref"
        class="flex w-full"
      >
        <div class="w-full relative">
          <div class="w-full flex overflow-hidden bg-brand-background">
            <AtomsImage
              v-if="media?.mime?.includes('image')"
              class="w-full object-cover object-center group-hover:scale-110 duration-300"
              :class="imageClass"
              :media="media"
              sizeHint="quarter"
              :alt="imageAlt"
            />
          </div>
        </div>
      </a>

      <!-- Image -->

      <!-- Video -->
      <AtomsVideo
        v-if="media?.mime?.includes('video')"
        :src="media?.formats?.large?.url ?? media?.url"
        :type="media?.mime"
        :autoplay="true"
        class="w-full object-cover object-center"
        :class="aspectRatioClass"
      />
      <!-- Video -->
    </div>

    <!-- Image & Video -->

    <!-- Text -->
    <div
      v-if="title"
      class="w-full flex flex-col overflow-hidden p-2"
      :class="textWrapperClass"
    >
      <!-- Title -->
      <h3
        v-if="title"
        class="w-full text-xl mt-1 font-semibold text-brand-first"
        :class="titleClass"
        v-html="title"
      ></h3>
      <!-- Title -->
    </div>
    <!-- Text -->
  </div>
</template>
<script setup>
const props = defineProps({
  pin: { type: String },
  title: {
    type: String,
  },
  description: {
    type: String,
  },
  link: { type: String },
  target: { type: String },
  media: {
    type: Object,
  },
  position: { type: String, default: "left" },
  mediaSize: { type: String },
  background: { type: String },
  isotope: { type: Boolean, default: true },
});

import { computed } from 'vue';
import { useSiteSettingsStore } from "@/store/index";
import { getAspectClass } from "~/composables/utils";

const siteSettingsStore = useSiteSettingsStore();

const fancyboxHref = computed(() => {
  const path = props.media?.formats?.xlarge_webp?.url ??
               props.media?.formats?.large_webp?.url ??
               props.media?.formats?.medium_webp?.url ??
               props.media?.url;
  return `${baseUrl}${path}`;
});

const aspectRatioClass = computed(() => getAspectClass(props.mediaSize));

const imageClass = computed(() => (props.isotope ? '' : aspectRatioClass.value));

const imageAlt = computed(() => props.media?.alternativeText ?? props.title ?? props.media?.hash ?? props.media?.name);

const textWrapperClass = computed(() => ({
  'items-center': props.position === 'center',
  'items-end': props.position === 'right',
}));

const titleClass = computed(() => [
  props.position === 'center' ? 'text-center' : props.position === 'right' ? ' text-right' : 'text-left',
  props.background === 'first' ? '!text-brand-first' : props.background === 'second' ? 'text-brand-second' : 'text-brand-first',
]);

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.baseUrl;
</script>
